import type { SVGProps } from 'react';
const DawnFlagJE = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-JE_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-JE_svg__a)">
      <path fill="#E3243B" d="m-4.959-2.066 1.202-1.748 31.752 22.637-1.202 1.748z" />
      <path fill="#E3243B" d="m27.995-2.066-1.202-1.748-31.752 22.637 1.202 1.748z" />
      <path
        fill="#FAEF32"
        fillRule="evenodd"
        d="M12.367 2.133H10.68l.069-.04-.775-.457 1.002.114-.14-.683.688.57.69-.57-.141.683 1.002-.114-.775.456z"
        clipRule="evenodd"
      />
      <path
        fill="#E3243B"
        fillRule="evenodd"
        d="M9.952 4.133v-.666c0-.737.597-1.334 1.334-1.334h.476c.736 0 1.333.597 1.333 1.334v.666c0 1.429-1.571 2-1.571 2s-1.572-.571-1.572-2"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-JE_svg__b"
        width={5}
        height={5}
        x={9}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M9.952 4.133v-.666c0-.737.597-1.334 1.334-1.334h.476c.736 0 1.333.597 1.333 1.334v.666c0 1.429-1.571 2-1.571 2s-1.572-.571-1.572-2"
          clipRule="evenodd"
        />
      </mask>
      <g fill="#FAEF32" mask="url(#dawn-flag-JE_svg__b)">
        <rect width={0.524} height={0.533} x={11.262} y={5.333} rx={0.262} />
        <rect width={2.095} height={0.533} x={10.476} y={4.267} rx={0.267} />
        <rect width={2.095} height={0.533} x={10.476} y={3.2} rx={0.267} />
      </g>
    </g>
  </svg>
);
export default DawnFlagJE;
